/* eslint-disable react/prop-types */
import React from 'react';
import { DownOutlined, QuestionCircleOutlined, UpOutlined,  } from '@ant-design/icons';
import { Statistic, Tooltip, Typography,  } from 'antd';

import styles from './StatCard.less';

const { Text } = Typography;

/**
 * StatCard —— 指标卡（看板 KPI 卡）
 * ------------------------------------------------------------------
 * 对应商家端「核心指标 / 今日运营实时 / 会员打卡 KPI」那种卡片：
 *   标题(+说明icon) / 大数字+单位 / 环比 / 底部辅助文案，支持整卡点击跳转。
 *
 * @param title      指标名，如「今日到店人数」
 * @param value      指标值（数字或已格式化的字符串）
 * @param unit       单位后缀，如「人」「次」「%」「台」
 * @param precision  小数位（value 为数字时生效）
 * @param hint       卡片底部的浅灰说明，如「去重人数」「未到店会员线上打卡」
 * @param tips       标题旁的问号 Tooltip 文案（口径解释）
 * @param trend      环比：{ rate: '12.5%', direction: 'up' | 'down' }
 * @param trendLabel 环比前缀文案，默认「环比」
 * @param onClick    整卡点击（截图中「点击查看今日到店明细」这类入口）
 * @param extra      右上角自定义内容
 */
const StatCard = (props) => {
  const {
    title,
    value,
    unit,
    precision,
    hint,
    tips,
    trend,
    trendLabel = '环比',
    onClick,
    extra,
    loading,
    className,
    align = 'left',
  } = props;

  const clickable = typeof onClick === 'function';
  const isEmpty = value === undefined || value === null || value === '';

  let display = value;
  if (isEmpty) display = '-';

  return (
    <div
      className={`${styles.card} ${clickable ? styles.clickable : ''} ${
        loading ? styles.loading : ''
      } ${className || ''}`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') onClick();
            }
          : undefined
      }
    >
      <div className={styles.head}>
        <Text className={styles.title}>{title}</Text>
        {tips && (
          <Tooltip title={tips}>
            <QuestionCircleOutlined className={styles.tipIcon} />
          </Tooltip>
        )}
        {extra && <span className={styles.extra}>{extra}</span>}
      </div>

      <div className={styles.valueRow}>
        {loading ? (
          <span className={styles.skeleton} />
        ) : (
          <Statistic
            className={`${styles.value} ${
              align === 'center' ? styles.center : ''
            }`}
            value={display}
            precision={isEmpty ? undefined : precision}
          />
        )}
        {unit && !isEmpty && <span className={styles.unit}>{unit}</span>}
      </div>

      <div className={styles.foot}>
        {trend && trend.rate !== undefined && trend.rate !== null && (
          <span className={styles.trend}>
            <Text className={styles.trendLabel}>{trendLabel}</Text>
            <span
              className={`${styles.trendValue} ${
                trend.direction === 'down' ? styles.down : styles.up
              }`}
            >
              {trend.direction === 'down' ? (
                <DownOutlined className={styles.trendIcon} />
              ) : (
                <UpOutlined className={styles.trendIcon} />
              )}
              {trend.rate}
            </span>
          </span>
        )}
        {hint && <Text className={styles.hint}>{hint}</Text>}
      </div>
    </div>
  );
};

export default StatCard;
